import React, { useMemo } from 'react';
import { VehicleParameterItem } from './VehicleParameterItem';

interface VehicleParametersProps {
  vehicleData: {
    brand: string;
    model: string;
    productionYear: string;
    vin: string;
    mileage: string;
    countryOfOrigin: string;
    fuelType: string;
    engineDisplacement: string;
    enginePower: string;
    driveType: string;
    engineLayout: string;
    transmission: string;
    bodyType: string;
    doorCount: string;
    color: string;
    maxWeight: string;
  };
}

export const VehicleParameters: React.FC<VehicleParametersProps> = ({
  vehicleData,
}) => {
  const fillColor = useMemo(() => '#A4B2C0', []);

  return (
    <div className="flex max-w-[834px] flex-wrap items-center gap-5 rounded-2xl border border-solid border-violet-100 bg-white py-5">
      <VehicleParameterItem label="Marka" value={vehicleData.brand} icon="people-group" fillColor={fillColor} />
      <VehicleParameterItem label="Model" value={vehicleData.model} icon="sun" fillColor={fillColor} />
      <VehicleParameterItem
        label="Rok produkcji"
        value={vehicleData.productionYear}
        icon="calendar-date"
        fillColor={fillColor}
      />
      <VehicleParameterItem label="Numer VIN" value={vehicleData.vin} icon="vin-number" fillColor={fillColor} />
      <VehicleParameterItem label="Przebieg" value={vehicleData.mileage} icon="speedometer" fillColor={fillColor} />
      <VehicleParameterItem
        label="Kraj pochodzenia"
        value={vehicleData.countryOfOrigin}
        icon="location-pin"
        fillColor={fillColor}
      />
      <VehicleParameterItem
        label="Rodzaj paliwa"
        value={vehicleData.fuelType}
        icon="location-bookmark"
        fillColor={fillColor}
      />
      <VehicleParameterItem
        label="Objętość skokowa silnika (cm³)"
        value={vehicleData.engineDisplacement}
        icon="loading-circle"
        fillColor={fillColor}
      />
      <VehicleParameterItem
        label="Moc silnika (KM/kW)"
        value={vehicleData.enginePower}
        icon="person-standing"
        fillColor={fillColor}
      />
      <VehicleParameterItem
        label="Rodzaj napędu"
        value={vehicleData.driveType}
        icon="network-connection"
        fillColor={fillColor}

      />
      <VehicleParameterItem
        label="Układ silnika / Ilość cylindrów"
        value={vehicleData.engineLayout}
        icon="handshake"
        fillColor={fillColor}
      />
      <VehicleParameterItem
        label="Skrzynia biegów"
        value={vehicleData.transmission}
        icon="network-diagram"
        fillColor={fillColor}
      />
      <VehicleParameterItem label="Typ nadwozia" value={vehicleData.bodyType} icon="car" fillColor={fillColor} />
      <VehicleParameterItem
        label="Liczba drzwi"
        value={vehicleData.doorCount}
        icon="car-door"
        fillColor={fillColor}
      />
      <VehicleParameterItem label="Kolor" value={vehicleData.color} icon="warning-shield" fillColor={fillColor} />
      <VehicleParameterItem
        label="Dopuszczalna masa całkowita:"
        value={vehicleData.maxWeight}
        icon="person-shirt"
        fillColor={fillColor}
      />
    </div>
  );
};
